(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["appointment-options"] && !Shopify.designMode) return;
  try {
    
  /*
   * Calendly popup trigger. Delegated so it covers every [data-calendly-popup]
   * CTA without per-button wiring. Progressive enhancement: if Calendly hasn't
   * loaded yet, we don't preventDefault — the anchor's href opens the
   * scheduling page directly.
   */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-calendly-popup]');
    if (!trigger) return;
    var url = trigger.getAttribute('data-calendly-popup');
    if (!url) return;
    if (window.Calendly && typeof window.Calendly.initPopupWidget === 'function') {
      event.preventDefault();
      window.Calendly.initPopupWidget({ url: url });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  /*
   * Header cart-count refresh.
   * Listens for mdj:cart-add-success (dispatched by <heritage-pdp-form>)
   * and mdj:cart-updated (dispatched by <heritage-cart> on qty/remove)
   * and updates the badge without a page reload.
   */
  (function () {
    function refresh(itemCount) {
      var nodes = document.querySelectorAll('[data-heritage-cart-count]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = String(itemCount);
        if (itemCount > 0) nodes[i].removeAttribute('hidden');
        else nodes[i].setAttribute('hidden', '');
      }
    }
    document.addEventListener('mdj:cart-add-success', function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (cart && typeof cart.item_count === 'number') refresh(cart.item_count);
    });
    document.addEventListener('mdj:cart-updated', function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (cart && typeof cart.item_count === 'number') refresh(cart.item_count);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
